import { SportType } from 'modules/core/domain/enums/sport-type';
import { DataMapper } from 'modules/core/domain/interfaces/data-mapper';
import { TournamentListItem, TournamentListItemDto } from '../interfaces/tournament-list-item';

export class TournamentListItemDataMapper implements DataMapper<TournamentListItem, TournamentListItemDto> {
  decode(dto: TournamentListItemDto): TournamentListItem {
    const logoImage = dto.images?.find((img) => img.type?.toLowerCase() === 'logo') ?? dto.images?.[0];

    return {
      id: dto.id,
      name: dto.name,
      sportType: dto.sportType?.toLowerCase() as SportType | undefined,
      phone: dto.phone,
      email: dto.email,
      createdAt: dto.createdAt,
      description: dto.description,
      logoUrl: logoImage?.externalUrl,
      address: dto.address ? { city: dto.address.city, country: dto.address.country } : undefined,
      adminUser: dto.adminUser
        ? {
            id: dto.adminUser.id,
            name: dto.adminUser.name,
            surname: dto.adminUser.surname,
            middleName: dto.adminUser.middleName,
          }
        : undefined,
    };
  }

  encode(entity: TournamentListItem): TournamentListItemDto {
    return {
      id: entity.id,
      name: entity.name,
      sportType: entity.sportType,
      phone: entity.phone,
      email: entity.email,
      createdAt: entity.createdAt,
      description: entity.description,
      images: entity.logoUrl ? [{ type: 'LOGO', externalUrl: entity.logoUrl, createdAt: '' }] : [],
      address: entity.address ? { city: entity.address.city, country: entity.address.country } : undefined,
      adminUser: entity.adminUser ? { ...entity.adminUser, createdAt: '', updatedAt: '' } : undefined,
    };
  }
}
